import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  "data-aos": "fade-up",
  class: "text-center flex-1 flex flex-col px-4 lg:px-8 lg:w-full mt-8 lg:mt-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "flex justify-end space-x-8" }
const _hoisted_4 = { class: "mt-4 mb-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_6 = { class: "flex items-center justify-center space-x-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "download your data", -1)
const _hoisted_8 = {
  key: 0,
  class: "mx-auto mb-4 flex flex-center space-x-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "file is ready!", -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "shadow-lg" }
const _hoisted_12 = { class: "grid grid-cols-3 lg:grid-cols-7 font-display bg-palette3 text-white rounded-t py-4" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "delete", -1)
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = {
  key: 0,
  class: "flex justify-center items-center space-x-3"
}
const _hoisted_20 = {
  key: 1,
  class: ""
}
const _hoisted_21 = {
  key: 2,
  class: ""
}
const _hoisted_22 = {
  key: 3,
  class: ""
}
const _hoisted_23 = ["onClick"]

import dayjs from "dayjs";
import { deleteCard } from "../server";

import relativeTime from "dayjs/plugin/relativeTime";
//import MyCard from "../components/MyCard.vue";
import MyButton from "../components/MyButton.vue";
import { computed, onMounted, Ref, ref } from "vue";
import { CardData } from "@/CardData";
import { sortBy } from "lodash";
import { CardDataDeckDisplay } from "@/CardDataDeckDisplay";
import { DeckConverter } from "@/DeckConverter";
import { store } from "@/store";
import { isMobileScreen } from "@/screenSize";
import YesOrNoIcon from "@/components/YesOrNoIcon.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

dayjs.extend(relativeTime);

const cards: Ref<CardDataDeckDisplay[]> = ref([]);
const asCsv: Ref<string> = ref("");

const csvBlob = computed(() => new Blob([asCsv.value], { type: "text/csv" }));
const csvDownloadUrl = computed(() => {
  if (asCsv.value) return URL.createObjectURL(csvBlob.value);
  return "";
});

const isMobile = computed(() => isMobileScreen());

function exportToCsv() {
  let converter = new DeckConverter();
  asCsv.value = converter.toCsv(cards.value);
}
function remove(card: CardData) {
  store.commit("removeCard", card);
  let sessionId = store.state.sessionId;
  if (!sessionId) throw new Error("sessionId is required");
  deleteCard(card, sessionId);
  reloadCards();
}
function reloadCards() {
  let rawCards = store.state.user?.cards ?? [];
  let sorted: CardData[] = sortBy(rawCards, (x: CardData) => x.dueDate);
  cards.value = sorted.map((c) => {
    let card = new CardData();
    Object.assign(card, c);
    let result = new CardDataDeckDisplay(card);
    Object.assign(result, c);
    return result;
  });
}

onMounted(() => reloadCards());

// @ts-ignore
function sortCardsBy(selector: any): void {
  cards.value = sortBy(cards.value, selector);
}

function sortByProgress() {
  sortCardsBy((c:CardData) => c.getProgress());
}
function sortByFront() {
  sortCardsBy((c:CardData) => c.front);
}
function sortByBack() {
  sortCardsBy((c:CardData) => c.back);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, "count: " + _toDisplayString(cards.value.length), 1),
      _hoisted_5,
      _createVNode(MyButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exportToCsv())),
        class: "mb-4",
        width: "w-auto"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_font_awesome_icon, { icon: "file-download" })
          ])
        ]),
        _: 1
      })
    ]),
    (_unref(csvDownloadUrl))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("a", {
            href: _unref(csvDownloadUrl),
            download: "your-data.csv",
            class: "underline text-palette2"
          }, "click here to download csv file", 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (sortByFront()))
        }, "word"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (sortByBack()))
        }, "translation"),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortByProgress()))
            }, "status"))
          : _createCommentVNode("", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "next review"))
          : _createCommentVNode("", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, "image"))
          : _createCommentVNode("", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, "audio"))
          : _createCommentVNode("", true),
        _hoisted_16
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
        return (_openBlock(), _createElementBlock("div", {
          key: card.front,
          class: "grid grid-cols-3 lg:grid-cols-7 py-4 odd:bg-gray-100 rounded text-sm"
        }, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(card.front), 1),
          _createElementVNode("p", _hoisted_18, _toDisplayString(card.back), 1),
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass(`rounded w-4 h-4 bg-${card.progressColor}`)
                }, null, 2),
                _createElementVNode("p", null, _toDisplayString(card.progressDisplay), 1)
              ]))
            : _createCommentVNode("", true),
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(card.nextReviewDisplay), 1))
            : _createCommentVNode("", true),
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                _createVNode(YesOrNoIcon, {
                  value: card.image?.url != undefined
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                _createVNode(YesOrNoIcon, {
                  value: card.audio?.url != undefined
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: ($event: any) => (remove(card)),
            class: "text-error"
          }, "🗑️", 8, _hoisted_23)
        ]))
      }), 128))
    ])
  ]))
}
}

})